import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {RolesGrantsResourcesFilters} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';


export const rolesGrantsResourcesStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    RolesGrantsResourcesFilters
>('rolesGrantsResourcesState', undefined);

export const rolesGrantsResourcesStateActions = rolesGrantsResourcesStateSlice.actions;
export const rolesGrantsResourcesStateSelector:
CachedTableStateSelector<undefined, undefined, RolesGrantsResourcesFilters> =
    state => state.manageEntitlements.rolesGrantsResourcesReducer.rolesGrantsResourcesState;
